module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAACCAYAAADl56r+AAAAAXNSR0IArs4c6QAAAB1JREFUKFNj/P//vzvDMAeMDAw7SPUi42jAYA8yAMrLB/13RLwMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/data.png
// module id = Stg2
// module chunks = 2